import { motion } from 'framer-motion';
import React from 'react';
import { useHistory } from 'react-router-dom';
import '../../Styles/About/AboutPage.css';
import HomeBackgroundEffect from '../Animation/HomeBackgroundEffect';
import AboutPageLogos from './AboutPageLogos';

const AboutPage = () => {
    const history = useHistory();

    return (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.5 }}>
            <div className="about-page-main-container flex-box">
                <HomeBackgroundEffect />
                <div className="about-introduction-container">
                    <motion.h2 initial={{ x: `500%` }} animate={{ x: 0 }} transition={{ duration: 1 }}>About Myself</motion.h2>
                    <br />
                    <motion.p initial={{ x: `-300%` }} animate={{ x: 0 }} transition={{ duration: 1 }}>
                        Hi 👋, I'm a curious and enthusiastic full-stack web developer with a good foundation in following libraries, frameworks and tools.
                        I'd like to work in a team and keep on learning new things throughout my life. With this, I intend to work and solve problems for
                        the betterment of society, an organization and myself.
                    </motion.p>
                </div>
                <div className="flex-box logo-container">
                    <AboutPageLogos />
                </div>
                <div className="flex-box about-page-buttons-container">
                    <div className="about-page-button about-page-button-left" onClick={() => history.push(`/`)}>Know less</div>
                    <div className="about-page-button about-page-button-right" onClick={() => history.push(`/projects`)}>Projects</div>
                </div>
            </div>
        </motion.div>
    )
}

export default AboutPage
